import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedReimaginedLoansIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const [loansData, dataSourceInfo, employerContributions, section127Info, contributionHistory] =
      await Promise.all([
        this.reimaginedData.fetchLoansData(),
        this.reimaginedData.getDataSourceInfo(),
        this.reimaginedData.fetchEmployerContributions(),
        this.reimaginedData.fetchSection127Info(),
        this.reimaginedData.fetchContributionHistory(),
      ]);

    // Check if user has run strategy finder before
    const employee = this.sessionContext.currentEmployee;
    const hasStrategyFinderResults = (employee?.strategyFinderResults?.length ?? 0) > 0;

    return {
      ...loansData,
      dataSourceInfo,
      employerContributions,
      section127Info,
      contributionHistory,
      hasStrategyFinderResults,
    };
  }
}
